import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { CheckCircle2, AlertTriangle, Mic } from "lucide-react";

export default function Confirm() {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, ok: false, data: null, error: "" });

  useEffect(() => {
    api.get(`/confirm/${token}`)
      .then(({ data }) => setState({ loading: false, ok: true, data, error: "" }))
      .catch((err) => setState({
        loading: false, ok: false, data: null,
        error: err?.response?.data?.detail || "We couldn't confirm that link.",
      }));
  }, [token]);

  return (
    <div style={{ minHeight: "100vh", background: "var(--pgm-cream)", display: "flex", alignItems: "center", justifyContent: "center", padding: 24 }}>
      <div className="pgm-card" style={{ maxWidth: 520, width: "100%", padding: 36, textAlign: "center" }} data-testid="confirm-page">
        <div style={{ width: 60, height: 60, background: state.ok ? "var(--pgm-olive)" : "var(--pgm-orange)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 18px" }}>
          {state.loading ? <Mic size={26} color="var(--pgm-cream)" />
            : state.ok ? <CheckCircle2 size={28} color="var(--pgm-cream)" />
            : <AlertTriangle size={26} color="var(--pgm-cream)" />}
        </div>
        {state.loading && <p style={{ opacity: 0.7 }} data-testid="confirm-loading">Confirming…</p>}
        {!state.loading && state.ok && (
          <>
            <div className="pgm-micro">◆ You're confirmed</div>
            <h1 className="pgm-display" style={{ fontSize: 32, lineHeight: 1.1, marginTop: 6 }} data-testid="confirm-heading">
              Thank you{state.data?.guest_first_name ? `, ${state.data.guest_first_name}` : ""}!
            </h1>
            <p style={{ fontSize: 15, lineHeight: 1.6, marginTop: 10 }} data-testid="confirm-message">
              We've let {state.data?.show_name || "the show"} know you'll be there. Nothing else to do — see you at the recording.
            </p>
          </>
        )}
        {!state.loading && !state.ok && (
          <>
            <h1 className="pgm-display" style={{ fontSize: 28, lineHeight: 1.1 }} data-testid="confirm-heading">Link not valid</h1>
            <p style={{ fontSize: 14, opacity: 0.8, marginTop: 10 }} data-testid="confirm-error">{state.error}</p>
            <p style={{ fontSize: 13, opacity: 0.7 }}>You can simply reply to the email instead and we'll mark you confirmed.</p>
          </>
        )}
      </div>
    </div>
  );
}
